<template>
  <div class="historial-slots">
    <b-card>
      <div class="tabla-wrapper">
        <table class="tabla-resumen">
          <thead>
            <tr>
              <th class="sticky-col">Categoria</th>
              <th class="sticky-col">Equipo</th>

              <th v-for="slot in historial.slots" :key="slot">
                {{ formatSlot(slot) }}
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="equipo in historial.equipos" :key="equipo.id_equipo">
              <td class="sticky-col nombre-equipo">
                {{ equipo.categoria }}
              </td>
              <td class="sticky-col nombre-equipo">
                {{ equipo.equipo }}
              </td>

              <td
                v-for="slot in historial.slots"
                :key="slot"
                :style="getHeatStyle(equipo.slots && equipo.slots[slot])"
              >
                {{ (equipo.slots && equipo.slots[slot]) || 0 }}
              </td>
            </tr>

            <!-- <tr v-if="!historial.equipos || historial.equipos.length === 0">
              <td :colspan="historial.slots.length + 1" class="empty">
                No hay datos disponibles
              </td>
            </tr> -->
          </tbody>
        </table>
      </div>
    </b-card>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import { BCard } from 'bootstrap-vue'

export default {
  components: {
    BCard,
  },

  props: {
    historial: {
      type: Object,
      default: () => ({
        equipos: [],
        slots: [],
      }),
    },
  },

  setup(props) {
    // 🔥 calcular máximo dinámico
    const maxValor = computed(() => {
      if (!props.historial?.equipos?.length) return 1

      return Math.max(
        ...props.historial.equipos.flatMap(
          e =>
            // eslint-disable-next-line
            props.historial.slots.map(
              s => Number((e.slots && e.slots[s]) || 0),
              // eslint-disable-next-line
            ),
          // eslint-disable-next-line
        ),
      )
    })

    // 🎨 heatmap dinámico (rojo → fuerte)
    const getHeatStyle = valor => {
      const v = Number(valor) || 0

      if (v === 0) return 'background-color: #f5f5f5'

      const ratio = v / maxValor.value

      const lightness = 90 - ratio * 50
      const color = `hsl(0, 70%, ${lightness}%)` // 🔴 rojo

      return `background-color: ${color}; color: ${
        ratio > 0.6 ? 'white' : 'black'
      }`
    }

    function formatSlot(slot) {
      const [dia, hora] = slot.split('_')
      return `${dia} ${hora}`
    }

    return {
      getHeatStyle,
      formatSlot,
    }
  },
}
</script>

<style scoped>
.historial-slots {
  margin: 10px;
  font-family: Arial, sans-serif;
}

/* 🔥 MISMO CONTENEDOR */
.tabla-wrapper {
  height: calc(100vh - 300px);
  overflow: auto;
  border: 1px solid #ddd;
  border-radius: 10px;
}

/* 🔥 MISMA TABLA */
.tabla-resumen {
  width: 100%;
  border-collapse: collapse;
  min-width: 800px;
}

.tabla-resumen th,
.tabla-resumen td {
  padding: 10px;
  text-align: center;
  border-bottom: 1px solid #eee;
}

/* HEADER STICKY */
.tabla-resumen thead th {
  position: sticky;
  top: 0;
  background: #ffffff;
  z-index: 3;
  font-weight: bold;
}

/* COLUMNA STICKY */
.sticky-col {
  position: sticky;
  left: 0;
  background: #fff;
  z-index: 2;
  text-align: left;
}

/* estilos */
.nombre-equipo {
  font-weight: 600;
  font-size: 12px;
}

/* empty */
.empty {
  padding: 20px;
  text-align: center;
  color: #999;
}
</style>
